<template>
<span v-cloak
      class="h-cart__link-count"
      v-bind:class="{'h-cart__link-count--notempty' : (this.comparecount>0)}"
>{{ this.comparecount }}</span>
</template>

<script>
import {mapGetters} from "vuex";

export default {
name: "cart-counter",
  computed: {
    ...mapGetters(["comparecount"]),
  }
}
</script>

<style scoped>

</style>